/**
 * View hooks for the lockbox read endpoints. Lockbox Domain types are already render-ready
 * (no bps/lamport rescaling needed beyond per-asset token formatting done at the component
 * boundary), so these are thin passthroughs over the Domain hooks — mirroring the
 * {@link ../view/vault-disclosures} precedent. Keep the seam so a future UI adapter can slot in
 * here without touching consumers.
 */

import {
    useLockboxAccessDomain,
    useLockboxByNftMintDomain,
    useLockboxDomain,
    useLockboxesByWalletDomain
} from "../domain/lockbox";

export function useLockboxAccess(params?: { skip?: boolean }) {
    return useLockboxAccessDomain(params);
}

export function useLockboxesByWallet(wallet: string | undefined) {
    return useLockboxesByWalletDomain(wallet);
}

export function useLockbox(address: string | undefined) {
    return useLockboxDomain(address);
}

export function useLockboxByNftMint(mint: string | undefined) {
    return useLockboxByNftMintDomain(mint);
}
